import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { IoCalendarOutline } from "react-icons/io5";
import {
  agregarMesaEnStockEnDemanada,
  armarPoliticas,
  armarPromociones,
  capitalizeFirstLetter,
  convertirFecha,
  getURLBasePath,
} from "../tools/utils";
import { AuthContext } from "../../context/AuthContext";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import { ProductContext } from "../../context/ProductContext";
import PasajerosAdultosForm from "./PasajerosAdultosForm";
import PasajerosMenorForm from "./PasajerosMenorForm";
import axios from "axios";

const FormularioReserva = () => {
  const navigate = useNavigate();
  const [loaded, setLoaded] = useState(false);
  const { setUsuario } = useContext(AuthContext);
  const [tiposDeDocumento, setTiposDeDocumento] = useState([]);
  const [datosPasajerosAdultos, setDatosPasajerosAdultos] = useState([]);
  const [datosPasajerosMenores, setDatosPasajerosMenores] = useState([]);
  const [token, setToken] = useState(null)
  const [observaciones, setObservaciones] = useState('');
  const [idEntidad, setIdEntidad] = useState(null)
  const [usuario, setUser] = useState(null)
  const { evento, reserva, setReserva, handleInputChange, calcularTotal } = useContext(ProductContext);
  const { mesas: mesasElegidas } = reserva;
  const [cantidadPasajeros, setCantidadPasajeros] = useState({
    adultos: 1,
    menores: 0,
  });
  const [mostrarModalEntidad, setMostrarModalEntidad] = useState(false);

  const [datosEntidad, setDatosEntidad] = useState({
    tipoDocumento: {
      id: ''
    },
    cuit: '',
    email: '',
    celular: '',
    razonSocial: '',
    cateIva: {
      idCategoriaAlIva: '3',
    },
    tipoEntidadG:
    {
      idTipoEntidadG: '1'
    },
    persJuridicaFisica: '2',
    nombreFantasia: '',
    rolEntidad: {
      idRol: 1
    },
    moneda: {
      idMoneda: 1
    }

  });
  useEffect(() => {
    window.scroll(0, 0);

    if (mesasElegidas.length > 0) {
      agregarMesaEnStockEnDemanada(evento.id, mesasElegidas, 0, 3);
      setReserva((prev) => ({ ...prev, mesas: [] }));
    }

    const sessionId = localStorage.getItem("sessionId");

    if (!sessionId) {
      const tokenn = localStorage.setItem("sessionId", generateSessionId());
      setToken(tokenn)
    } else {
      setToken(sessionId)
    }


    const data = { peticion: 8 };
    const url = `${getURLBasePath()}/serviciosEmpleados.php`;

    fetch(url, {
      method: "POST",
      body: JSON.stringify(data),
      headers: new Headers(),
    })
      .then((res) => res.json())
      .then((resultado) => {
        if (resultado) {
          setTiposDeDocumento(resultado);
        }
      })
      .catch((error) => console.error("Error:", error));
  }, []);

  useEffect(() => {
    const validacion = async () => {
      const usuario = localStorage.getItem("usuario");
      if (!usuario) {
        return (navigate("/auth/login"))
      }
      if (usuario === 'undefined') {
        return (navigate("/auth/login"))
      }
      const user = JSON.parse(usuario);

      if (!user.idEntidadG || user.idEntidadG === '0') {
        crearEntidadG();
      } else {
        setIdEntidad(user.idEntidadG)
      }

      setUser(user)

    }
    validacion()
  }, [])

  useEffect(() => {
    setDatosPasajerosAdultos(
      Array.from({ length: cantidadPasajeros.adultos }, () => ({
        nombre: "",
        apellido: "",
        idTipoDocumento: "",
        numeroDoc: "",
        fechaNacimiento: "",
        sexo: "",
        email: "",
        celular: "",
        estado: "1",
        tipo: "A",
        ideventosEmbarques: ""
      }))
    );

    setDatosPasajerosMenores(
      Array.from({ length: cantidadPasajeros.menores }, () => ({
        nombre: "",
        apellido: "",
        idTipoDocumento: "",
        numeroDoc: "",
        fechaNacimiento: "",
        sexo: "",
        email: "mismoque@padre",
        celular: "11223344",
        estado: "1",
        tipo: "M",
        ideventosEmbarques: ""

      }))
    );
  }, [cantidadPasajeros]);

  const generateSessionId = () => {
    const cryptoNumber = ([1e7] + -1e3 + -4e3 + -8e3).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
    return `${cryptoNumber}-${Date.now()}`;
  };

  const handleChangeAdulto = (index, field, value) => {
    const nuevosDatos = [...datosPasajerosAdultos];
    nuevosDatos[index][field] = value;
    setDatosPasajerosAdultos(nuevosDatos);
  };

  const handleChangeMenor = (index, field, value) => {
    const nuevosDatos = [...datosPasajerosMenores];
    nuevosDatos[index][field] = value;
    setDatosPasajerosMenores(nuevosDatos);
  };

  const crearEntidadG = async () => {
    setMostrarModalEntidad(true);
  };

  const validarCampos = () => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const validarGrupo = (pasajeros, etiqueta) => {
    for (const pasajero of pasajeros) {
      for (const [clave, valorRaw] of Object.entries(pasajero)) {
        if (clave === "ideventosEmbarques") continue;

        const valor = (valorRaw ?? "").toString().trim();

        // Vacíos (excepto embarque que ya excluimos)
        if (valor === "") {
          toast.error(`Debe completar todos los campos de los pasajeros ${etiqueta}.`, {
            duration: 4000,
            position: "top-center",
          });
          return false;
        }

        // Email
        if (clave === "email" && !emailRegex.test(valor)) {
          toast.error("El formato del correo electrónico es inválido.", {
            duration: 4000,
            position: "top-center",
          });
          return false;
        }
      }

      // Punto de embarque si el producto lo requiere
      if (
        evento?.productoM?.idProducto === 4 &&
        !((pasajero.ideventosEmbarques ?? "").toString().trim())
      ) {
        toast.error(`Debe seleccionar un punto de embarque para todos los pasajeros ${etiqueta}.`, {
          duration: 4000,
          position: "top-center",
        });
        return false;
      }
    }
    return true;
  };

  if (!validarGrupo(datosPasajerosAdultos, "adultos")) return false;
  if (!validarGrupo(datosPasajerosMenores, "menores")) return false;

  return true;
};




  const handleSiguienteClick = async (e) => {


    if (validarCampos()) {

      e.preventDefault();

      if (
        parseInt(reserva.paxAdultos) > 10 ||
        parseInt(reserva.paxMenores) > 10 ||
        parseInt(reserva.paxAdultos) + parseInt(reserva.paxMenores) > 10
      ) {
        toast.error("Podrá reservar un máximo de 10 personas.", {
          duration: 4000,
          position: "top-center",
        });
        setReserva((prev) => ({
          ...prev,
          pasajeros: {
            paxAdultos: "",
            paxMenores: ""
          },
        }));
        return;
      }

      const pasajeros = {
        datosPasajerosAdultos,
        datosPasajerosMenores

      };

      const listaPasajeros = [
        ...pasajeros.datosPasajerosAdultos,
        ...pasajeros.datosPasajerosMenores
      ];


     
      const fecha = new Date();
      const fechaFormateada = fecha.toISOString().split('T')[0]; // Ej: "2025-04-15"

     

        if(parseInt(usuario.idTipoEntidadG) === 3 || parseInt(usuario.idTipoEntidadG) === 4 || parseInt(usuario.idTipoEntidadG) === 5){
         const reserva = {
          evento: evento,
            sessionId: token,
            idEntidad: idEntidad,
            idEvento: evento.idEvento,
            listaPasajeros: listaPasajeros,
            tarifaBaseAdulto: evento.productoM.tarifasM.tarifaAdulto,
            tarifaBaseMenor: evento.productoM.tarifasM.tarifaMenor,
            paxTotales: (datosPasajerosAdultos.length + datosPasajerosMenores.length),
            paxMenores: datosPasajerosMenores.length,
            paxLiberados: 0,
            fechaVencimientoFormatoSQL: fechaFormateada,
            idUsuario: 7,
            observacion: observaciones,
            idCanal: 2,
            idVendedor: 4,
            vendedor: {
              comision: 0,
              comoAplica: 1,
            },
            idModo: 0,
            compartir: 1,
            aplicarPoliticaPrecio: 1,
            aplicarPromocionPrecio: 1,
            bitacoraText: `${usuario.nombre_completo} ${fecha}`,
            ArrayParaTotalProducto: [],
            datosPago: {},
            idCharter: 0,
            idTipoDocumento: pasajeros.datosPasajerosAdultos[0].idTipoDocumento,
            numeroDocumento: pasajeros.datosPasajerosAdultos[0].numeroDoc,
            titular: `${usuario.nombre_completo}`,
            telefono: pasajeros.datosPasajerosAdultos[0].celular,
            email: pasajeros.datosPasajerosAdultos[0].email,
            direccion: 'a definir',
            totalReserva: (Number(parseFloat(evento.productoM.tarifasM.tarifaAdulto) || 0) * datosPasajerosAdultos.length +
              Number(parseFloat(evento.productoM.tarifasM.tarifaMenor) || 0) * datosPasajerosMenores.length
            ).toFixed(2)
          
         }
         
          try {
           let medioDePago;

            if (parseInt(usuario.idTipoEntidadG) === 3) {
              medioDePago = 'Agencia';
            } else if (parseInt(usuario.idTipoEntidadG) === 4) {
              medioDePago = 'Freelance';
            } else {
              medioDePago = 'Sindicato';
            }
                        

            const url = `https://estanciamargarita.com.ar/backendGama/php/servicios/serviciosReserva.php`;
          const data = { peticion: 30, reserva: reserva, medioDePago: medioDePago };
          const response = await axios.post(url, data);
         // console.log(response.data)

          if (response.data.estado !== 'error' || response.data.mensaje!=='error' ) {

            toast.success("Reserva realizada con éxito.", {
              duration: 4000,
              position: "top-center",
            });
            navigate("/auth/profile");
          } else {
            toast.error("Error al realizar la reserva. Intente nuevamente.", {
              duration: 4000,
              position: "top-center",
            });
             toast.error(`${response.data.mensaje}`, {
              duration: 4000,
              position: "top-center",
            })
            return;
          }
          }
           catch (error) {
        console.error('Error al enviar los datos:', error);
        toast.error("Error al enviar los datos. Intente nuevamente.", {
          duration: 4000,
          position: "top-center",
        });
        toast.error(`${error}`, {
          duration: 4000,
          position: "top-center",
        });
        return;
      }
        } else {
         
          // setReserva((prev) => ({
          //   ...prev,
          //   evento: evento,
          //   idEntidad: idEntidad,
          //   idEvento: evento.idEvento,
          //   listaPasajeros: listaPasajeros,
          //   tarifaBaseAdulto: evento.productoM.tarifasM.tarifaAdulto,
          //   tarifaBaseMenor: evento.productoM.tarifasM.tarifaMenor,
          //   paxTotales: (datosPasajerosAdultos.length + datosPasajerosMenores.length),
          //   paxMenores: datosPasajerosMenores.length,
          //   paxLiberados: 0,
          //   fechaVencimientoFormatoSQL: fechaFormateada,
          //   idUsuario: 7,
          //   observacion: observaciones,
          //   idCanal: 2,
          //   idVendedor: 4,
          //   vendedor: {
          //     comision: 0,
          //     comoAplica: 1,
          //   },
          //   idModo: 0,
          //   compartir: 1,
          //   aplicarPoliticaPrecio: 1,
          //   aplicarPromocionPrecio: 1,
          //   bitacoraText: `${usuario.nombre_completo} ${fecha}`,
          //   ArrayParaTotalProducto: [],
          //   idCharter: 0,
          //   idTipoDocumento: pasajeros.datosPasajerosAdultos[0].idTipoDocumento,
          //   numeroDocumento: pasajeros.datosPasajerosAdultos[0].numeroDoc,
          //   titular: `${pasajeros.datosPasajerosAdultos[0].nombre} ${pasajeros.datosPasajerosAdultos[0].apellido}`,
          //   telefono: pasajeros.datosPasajerosAdultos[0].celular,
          //   email: pasajeros.datosPasajerosAdultos[0].email,
          //   direccion: 'a definir',
          //   totalReserva: (Number(parseFloat(evento.productoM.tarifasM.tarifaAdulto) || 0) * datosPasajerosAdultos.length +
          //     Number(parseFloat(evento.productoM.tarifasM.tarifaMenor) || 0) * datosPasajerosMenores.length
          //   ).toFixed(2)
          // }));

          const reserva = {
             evento: evento,
            idEntidad: idEntidad,
            idEvento: evento.idEvento,
            listaPasajeros: listaPasajeros,
            tarifaBaseAdulto: evento.productoM.tarifasM.tarifaAdulto,
            tarifaBaseMenor: evento.productoM.tarifasM.tarifaMenor,
            paxTotales: (datosPasajerosAdultos.length + datosPasajerosMenores.length),
            paxMenores: datosPasajerosMenores.length,
            paxLiberados: 0,
            fechaVencimientoFormatoSQL: fechaFormateada,
            idUsuario: 7,
            observacion: observaciones,
            idCanal: 2,
            idVendedor: 4,
            vendedor: {
              comision: 0,
              comoAplica: 1,
            },
            idModo: 0,
            compartir: 1,
            aplicarPoliticaPrecio: 1,
            aplicarPromocionPrecio: 1,
            bitacoraText: `${usuario.nombre_completo} ${fecha}`,
            ArrayParaTotalProducto: [],
            idCharter: 0,
            idTipoDocumento: pasajeros.datosPasajerosAdultos[0].idTipoDocumento,
            numeroDocumento: pasajeros.datosPasajerosAdultos[0].numeroDoc,
            titular: `${pasajeros.datosPasajerosAdultos[0].nombre} ${pasajeros.datosPasajerosAdultos[0].apellido}`,
            telefono: pasajeros.datosPasajerosAdultos[0].celular,
            email: pasajeros.datosPasajerosAdultos[0].email,
            direccion: 'a definir',
            totalReserva: (Number(parseFloat(evento.productoM.tarifasM.tarifaAdulto) || 0) * datosPasajerosAdultos.length +
              Number(parseFloat(evento.productoM.tarifasM.tarifaMenor) || 0) * datosPasajerosMenores.length
            ).toFixed(2)
          }
          setReserva(reserva);
          //console.log(reserva);
          //console.log('Navegando a ModoPago...');
          navigate("/reserva/ModoPago");

        }

    }
    else {
      console.error('Hay un error al siguiente Click.')
    }
  };

  const handleEnviarDatosEntidad = async () => {
    if (!datosEntidad.celular && !datosEntidad.documento && !datosEntidad.idTipoDocumento && !datosEntidad.email) {
      return (
        toast.error("Debe completar todos los datos.", {
          duration: 4000,
          position: "top-center",
        }))
    }
    if (!usuario) {
      return (
        toast.error("Debe estar Logueado para proseguir.", {
          duration: 4000,
          position: "top-center",
        }))
    }
    try {

      const actualizarDatosEntidad = {
        ...datosEntidad,
        razonSocial: usuario.nombre_completo,
        nombreFantasia: usuario.nombre_completo
      }
      const data = {
        peticion: 1,
        param: {
          entidadesG: actualizarDatosEntidad,
          user: usuario
        }
      }


      const response = await axios.post('https://estanciamargarita.com.ar/backendGama/php/servicios/servicioEntidadG.php', data)
      // console.log(response)

      if (response.data.estado !== 'error') {

        const newUser = {
          ...usuario,
          idEntidadG: response.data.data
        }

        setUsuario(newUser);
        setUser(newUser);


        localStorage.setItem("usuario", JSON.stringify(newUser));

        toast.success("Formulario de cliente, completo.", {
          duration: 4000,
          position: "top-center",
        });

        setMostrarModalEntidad(false);
      } else {
        return toast.error(`${response.data.mensaje}`, {
          duration: 4000,
          position: "top-center",
        });
      }
    }
    catch (error) {
      console.error('No se puedo añadir la EntidadG al usuario. Error:', error)

    }
  }


  // console.log(idEntidad)
  return (
    <div>
      {mostrarModalEntidad && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg sm:max-w-sm  m-10 md:m-0 w-full md:max-w-2xl text-center shadow-lg">
            <h2 className="text-xl font-bebas mb-4">Formulario de cliente:</h2>
            <p className="mb-4  text-sm">Para poder realizar una reserva, debes completar el siguiente formulario, por unica vez.</p>
            <form className="bg-white p-10 rounded md:rounded-xl">


              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">

                <select
                  name="id"
                  value={datosEntidad.tipoDocumento.id}
                  onChange={(e) =>
                    setDatosEntidad((prev) => ({
                      ...prev,
                      tipoDocumento: {
                        ...prev.tipoDocumento,
                        id: e.target.value
                      }
                    }))
                  }
                  className="border rounded px-3 py-2 w-full focus:ring-2 focus:ring-orange-400"
                  style={{ height: "60px" }}
                >
                  <option disabled value="">
                    Tipo Documento
                  </option>
                  {tiposDeDocumento?.map((tipo) => (
                    <option key={tipo.id} value={tipo.id}>
                      {tipo.descripcion}
                    </option>
                  ))}
                </select>

                <input
                  type="text"
                  placeholder="Documento"
                  value={datosEntidad.cuit}
                  onChange={(e) =>
                    setDatosEntidad((prev) => ({
                      ...prev,
                      cuit: e.target.value
                    }))
                  }
                  className="border rounded px-3 py-2 w-full focus:ring-2 focus:ring-orange-400"
                />

                <input
                  type="text"
                  placeholder="Email"
                  value={datosEntidad.email}
                  onChange={(e) =>
                    setDatosEntidad((prev) => ({
                      ...prev,
                      email: e.target.value
                    }))
                  }
                  className="border rounded px-3 py-2 w-full focus:ring-2 focus:ring-orange-400"
                />

                <input
                  type="text"
                  placeholder="Celular"
                  value={datosEntidad.celular}
                  onChange={(e) =>
                    setDatosEntidad((prev) => ({
                      ...prev,
                      celular: e.target.value
                    }))
                  }
                  className="border rounded px-3 py-2 w-full focus:ring-2 focus:ring-orange-400"
                />

              </div>

              <Link
                className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded"
                onClick={() => handleEnviarDatosEntidad()}
              >
                Crear
              </Link>

            </form>
            <div className="flex justify-center gap-4">

              {/* <button
                className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded"
                onClick={() => setMostrarModalEntidad(false)}
              >
                Cancelar
              </button> */}
            </div>
          </div>
        </div>
      )}
      <div className="pt-20 md:m-20 text-white">
        <div className="bg-gray-700 p-10 md:p-5 md:rounded-xl">
          <div className="justify-center flex">
            <IoCalendarOutline className="h-9 w-7" />
            <h1 className="text-center font-bebas text-4xl">
              {capitalizeFirstLetter(convertirFecha(evento?.fecha))}.
            </h1>
          </div>
          <h5 className="text-lg font-montserrat text-center">
            Podrá reservar un máximo de 10 personas.
          </h5>
          <p className="text-center text-lg">
            <b>Tarifa por:</b>
            <br />
            Adultos: ${evento?.productoM.tarifasM.tarifaAdulto} - Menores: $
            {evento?.productoM.tarifasM.tarifaMenor}
          </p>
        </div>
      </div>

      {evento?.promocionMovArray?.length > 0 && (
        <p className="resaltar">
          <b>Promociones Vigentes</b>
          <br />
          {armarPromociones(evento)}
        </p>
      )}

      <div>
        {evento?.idEvento && (
          <form className="bg-white grid md:m-20 p-10 rounded md:rounded-xl">

            {/* SELECT CANTIDAD PASAJEROS. */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Cantidad de Adultos
                </label>
                <select
                  className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400 bg-gray-100 text-gray-700 border rounded"
                  onChange={(event) =>
                    setCantidadPasajeros((prev) => ({
                      ...prev,
                      adultos: Number(event.target.value),
                    }))
                  }
                >
                  <option value={1}>1</option>
                  <option value={2}>2</option>
                  <option value={3}>3</option>
                  <option value={4}>4</option>
                  <option value={5}>5</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Cantidad de Menores
                </label>
                <select
                  onChange={(event) =>
                    setCantidadPasajeros((prev) => ({
                      ...prev,
                      menores: Number(event.target.value),
                    }))
                  }
                  className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400  bg-gray-100 text-gray-700 border rounded "
                >
                  <option value={0}>0</option>
                  <option value={1}>1</option>
                  <option value={2}>2</option>
                  <option value={3}>3</option>
                </select>
              </div>
            </div>

            {/* FORMULARIO PASAJEROS. */}
            <div className="space-y-6">
              {/* Formularios Adultos */}

              {datosPasajerosAdultos.map((data, index) => (
                <PasajerosAdultosForm
                  key={`adulto-${index}`}
                  index={index}
                  data={data}
                  tiposDeDocumento={tiposDeDocumento}
                  onChange={handleChangeAdulto}
                  puntosEmbarque={evento?.embarques}
                />
              ))}

              {/* Formularios Menores */}
              {datosPasajerosMenores.map((data, index) => (
                <PasajerosMenorForm
                  key={`menor-${index}`}
                  index={index}
                  data={data}
                  tiposDeDocumento={tiposDeDocumento}
                  onChange={handleChangeMenor}
                  puntosEmbarque={evento?.embarques}
                />
              ))}
            </div>

            <div className="flex justify-center items-center ">
            </div>
            <div className="w-full px-3 mb-6">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                Observaciones
              </label>
              <textarea
                name="observacion"
                rows="5"
                value={observaciones}
                placeholder="Cualquier comentario que sienta oportuno que sepamos"
                onChange={(e) => setObservaciones(e.target.value)}
                className="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4"
              />
            </div>

            <div className="w-full px-3 mb-6">
              <Link
                className="float-left inline-flex items-center justify-center rounded bg-emerald-500 px-6 py-3 text-white hover:bg-emerald-600"
                to="/reserva/"
              >
                Volver
              </Link>
              <Link
                onClick={handleSiguienteClick}
                className="float-right inline-flex items-center justify-center rounded bg-emerald-500 px-6 py-3 text-white hover:bg-emerald-600"
              >
                Siguiente
              </Link>
            </div>

          </form>
        )}
      </div>
      <div className="max-w-4xl mx-auto p-6"></div>
    </div>
  );
};

export default FormularioReserva;
